export default __webpack_public_path__ + "static/media/join-us-mob.f3731184.png";